

// src/Admin.js
import React, { useState, useEffect } from "react";
import "./Admin.css";
import { useAuth } from "./AuthContext";

import {
  collection,
  getDocs,
  query,
  orderBy,
  doc,
  setDoc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "./firebase";

// 🔑 مفتاح ImgBB الذي أعطيتني إياه
const IMGBB_API_KEY = "d268b5a0428e23da9214491a9ab0e5a5";

// === رفع صورة إلى ImgBB وإرجاع الرابط المباشر ===
async function uploadImageToImgBB(file) {
  const formData = new FormData();
  formData.append("image", file);

  const res = await fetch(
    `https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`,
    {
      method: "POST",
      body: formData,
    }
  );

  if (!res.ok) {
    throw new Error("ImgBB HTTP error");
  }

  const data = await res.json();
  if (!data.success || !data.data || !data.data.url) {
    throw new Error("ImgBB upload failed");
  }

  // نرجع رابط الصورة المباشر
  return data.data.url;
}

export default function Admin() {
  const { user, signOut } = useAuth();

  // تبويب لوحة التحكم (أقسام / منتجات)
  const [activeTab, setActiveTab] = useState("categories"); // "categories" | "items"

  // ---------------------------
  // ١) إدارة الأقسام
  // ---------------------------

  const [catId, setCatId] = useState("");
  const [title, setTitle] = useState("");
  const [orderNum, setOrderNum] = useState(1);

  // غير مستخدمة حالياً؛ نخليها لو بتحتاجها لاحقاً
  const [catTitle, setCatTitle] = useState("");
  const [catOrder, setCatOrder] = useState("");

  // 🖼 مصفوفات بانرات القسم (حتى ٤ صور)
  const [bannerTopList, setBannerTopList] = useState([]);   // أعلى القسم
  const [bannerAfterList, setBannerAfterList] = useState([]); // بعد القسم

  const [cats, setCats] = useState([]);
  const [loadingCats, setLoadingCats] = useState(false);

  // حالة رفع للبانرات (عشان نمنع الضغط أثناء الرفع)
  const [uploadingTopBanners, setUploadingTopBanners] = useState(false);
  const [uploadingAfterBanners, setUploadingAfterBanners] = useState(false);

  // ---------------------------
  // ٢) إدارة المنتجات
  // ---------------------------

  const [selectedCatForItems, setSelectedCatForItems] = useState("");

  const [itemId, setItemId] = useState("");
  const [itemName, setItemName] = useState("");
  const [itemPrice, setItemPrice] = useState("");
  const [itemCalories, setItemCalories] = useState("");
  const [itemDesc, setItemDesc] = useState("");

  // === الإضافات (Extras) ===
const [extras, setExtras] = useState([]);
const [extraName, setExtraName] = useState("");
const [extraPrice, setExtraPrice] = useState("");

function removeExtra(index) {
  setExtras((prev) => prev.filter((_, i) => i !== index));
}


// === أنواع العجينة (Flour Types) ===
const [flourTypes, setFlourTypes] = useState([]);
const [flourInput, setFlourInput] = useState("");

function removeFlour(index) {
  setFlourTypes((prev) => prev.filter((_, i) => i !== index));
}



  // 🖼 مصفوفة صور المنتج (حتى ٤ صور) — الآن تَخزِن روابط فقط
  const [itemImages, setItemImages] = useState([]);
  const [itemImgUrl, setItemImgUrl] = useState("");

  const [itemsList, setItemsList] = useState([]);
  const [loadingItems, setLoadingItems] = useState(false);
  const [uploadingItemImages, setUploadingItemImages] = useState(false);

  // ---------------------------
  // تحميل الأقسام من Firestore
  // ---------------------------

  async function loadCategories() {
    setLoadingCats(true);
    try {
      const qCats = query(
        collection(db, "menuCategories"),
        orderBy("order", "asc")
      );
      const snap = await getDocs(qCats);
      const list = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));
      setCats(list);

      if (!selectedCatForItems && list.length > 0) {
        setSelectedCatForItems(list[0].id);
      }
    } catch (err) {
      console.error("loadCategories error:", err);
    } finally {
      setLoadingCats(false);
    }
  }

  useEffect(() => {
    loadCategories();
  }, []);

  // لما المستخدم يضغط "تعديل" على قسم
  function startEditCategory(cat) {
    setCatId(cat.id);
    setTitle(cat.title || "");
    setOrderNum(cat.order ?? 1);

    // نحول البيانات من الداتا القديمة/الجديدة إلى مصفوفات
    const topArr = Array.isArray(cat.bannerTopImages)
      ? cat.bannerTopImages
      : cat.bannerTop
      ? [cat.bannerTop]
      : [];

    const afterArr = Array.isArray(cat.bannerAfterImages)
      ? cat.bannerAfterImages
      : cat.bannerAfter
      ? [cat.bannerAfter]
      : [];

    setBannerTopList(topArr);
    setBannerAfterList(afterArr);

    setActiveTab("categories");
  }

  // حذف قسم كامل
  async function deleteCategory(id) {
    const yes = window.confirm(
      "تنبيه: حذف القسم راح يحذف بياناته من قاعدة البيانات (لكن ما يحذف العناصر داخله تلقائياً). هل أنت متأكد؟"
    );
    if (!yes) return;

    await deleteDoc(doc(db, "menuCategories", id));

    if (catId === id) {
      resetCategoryForm();
    }

    await loadCategories();

    if (selectedCatForItems === id) {
      setSelectedCatForItems("");
      setItemsList([]);
    }
  }

  // ✅ إخفاء/إظهار قسم
  async function toggleCategoryHidden(cat) {
    const newHidden = !cat.hidden;
    const text = newHidden
      ? "سيتم إخفاء هذا القسم من المنيو العام، هل أنت متأكد؟"
      : "سيتم إظهار هذا القسم في المنيو العام، هل أنت متأكد؟";
    const yes = window.confirm(text);
    if (!yes) return;

    try {
      await setDoc(
        doc(db, "menuCategories", cat.id),
        { hidden: newHidden },
        { merge: true }
      );
      await loadCategories();
      if (selectedCatForItems === cat.id) {
        await loadItemsOfCategory(cat.id);
      }
    } catch (err) {
      console.error("toggleCategoryHidden error:", err);
      alert("حصل خطأ أثناء التحديث، تأكد من اتصالك.");
    }
  }

  function resetCategoryForm() {
    setCatId("");
    setTitle("");
    setOrderNum(1);
    setBannerTopList([]);
    setBannerAfterList([]);
  }

  // ---------------------------
  // رفع / إدارة بانرات القسم (مصفوفات) — الآن ترفع للـ ImgBB
  // ---------------------------

  async function addBannerFiles(filesList, which) {
    if (!filesList || !filesList.length) return;

    const files = Array.from(filesList);
    const current = which === "top" ? bannerTopList : bannerAfterList;
    const remaining = 4 - current.length;

    if (remaining <= 0) {
      alert("يمكنك رفع حتى 4 صور فقط لكل مجموعة بانرات.");
      return;
    }

    const selected = files.slice(0, remaining);

    try {
      if (which === "top") setUploadingTopBanners(true);
      else setUploadingAfterBanners(true);

      // نرفع كل ملف إلى ImgBB ونحصل على روابط
      const urls = await Promise.all(
        selected.map((file) => uploadImageToImgBB(file))
      );

      const updated = [...current, ...urls];

      if (which === "top") {
        setBannerTopList(updated);
      } else {
        setBannerAfterList(updated);
      }
    } catch (err) {
      console.error("addBannerFiles (ImgBB) error:", err);
      alert("حصل خطأ أثناء رفع الصور إلى ImgBB، تأكد من اتصالك.");
    } finally {
      if (which === "top") setUploadingTopBanners(false);
      else setUploadingAfterBanners(false);
    }
  }

  async function handleBannerSelect(e, which) {
    const files = e.target.files;
    await addBannerFiles(files, which);
    e.target.value = "";
  }

  async function handleDrop(e, which) {
    e.preventDefault();
    const files = e.dataTransfer.files;
    await addBannerFiles(files, which);
  }

  function handleDragOver(e) {
    e.preventDefault();
  }

  function removeBannerImage(which, index) {
    if (which === "top") {
      setBannerTopList((prev) => prev.filter((_, i) => i !== index));
    } else {
      setBannerAfterList((prev) => prev.filter((_, i) => i !== index));
    }
  }

  // حفظ (إنشاء أو تعديل) القسم
  async function saveCategory() {
  if (!catId.trim()) {
    alert("الرجاء إدخال معرف القسم (ID مثلاً fatayer / pizza)");
    return;
  }

  if (!title.trim()) {
    alert("الرجاء إدخال اسم القسم");
    return;
  }

  const payload = {
    title: title || "",
    order: Number(orderNum) || 0,

    // البنرات كمصفوفات صحيحة
    bannerTopImages: bannerTopList,
    bannerAfterImages: bannerAfterList,

    // دعم للحقول القديمة (لتوافق App.js)
    bannerTop: bannerTopList[0] || "",
    bannerAfter: bannerAfterList[0] || "",
  };

  try {
    const ref = doc(db, "menuCategories", catId.trim());
    await setDoc(ref, payload, { merge: true });

    alert("تم حفظ القسم بنجاح ✅");
    await loadCategories();
    resetCategoryForm();

  } catch (err) {
    console.error("saveCategory error:", err);
    alert("حدث خطأ أثناء حفظ القسم");
  }
}

  // ---------------------------
  // تحميل منتجات قسم معيّن
  // ---------------------------

  async function loadItemsOfCategory(catDocId) {
    if (!catDocId) return;

    setLoadingItems(true);
    try {
      const qItems = query(
        collection(db, "menuCategories", catDocId, "items"),
        orderBy("order", "asc")
      );
      const snap = await getDocs(qItems);
      const list = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));
      setItemsList(list);
    } catch (err) {
      console.error("loadItemsOfCategory error:", err);
      setItemsList([]);
    } finally {
      setLoadingItems(false);
    }
  }

  useEffect(() => {
    if (selectedCatForItems) {
      loadItemsOfCategory(selectedCatForItems);
    }
  }, [selectedCatForItems]);

  function resetItemForm() {
    setItemId("");
    setItemName("");
    setItemPrice("");
    setItemCalories("");
    setItemDesc("");
    setItemImages([]);
    setItemImgUrl("");
    setExtras([]);
    setFlourTypes([]);

  }

  // تعبئة المنتج في الفورم للتعديل
  function startEditItem(item) {
    setItemId(item.id);
    setItemName(item.name || "");
    setItemPrice(item.price?.toString() || "");
    setItemCalories(item.calories?.toString() || "");
    setItemDesc(item.desc || "");

    setExtras(item.extras || []);
    setFlourTypes(item.flourTypes || []);


    const imgs = Array.isArray(item.itemImages)
      ? item.itemImages
      : item.img
      ? [item.img]
      : [];

    setItemImages(imgs);
    setItemImgUrl("");
    setActiveTab("items");
  }

  // حذف منتج من القسم الحالي
  async function deleteItem(itemIdToDelete) {
    if (!selectedCatForItems) return;
    const yes = window.confirm("حذف هذا المنتج نهائياً؟");
    if (!yes) return;

    await deleteDoc(
      doc(db, "menuCategories", selectedCatForItems, "items", itemIdToDelete)
    );
    await loadItemsOfCategory(selectedCatForItems);

    if (itemId === itemIdToDelete) {
      resetItemForm();
    }
  }

  // ✅ إخفاء/إظهار منتج
  async function toggleItemHidden(item) {
    if (!selectedCatForItems) return;
    const newHidden = !item.hidden;
    const text = newHidden
      ? "سيتم إخفاء هذا المنتج من المنيو العام، هل أنت متأكد؟"
      : "سيتم إظهار هذا المنتج في المنيو العام، هل أنت متأكد؟";
    const yes = window.confirm(text);
    if (!yes) return;

    try {
      await setDoc(
        doc(db, "menuCategories", selectedCatForItems, "items", item.id),
        { hidden: newHidden },
        { merge: true }
      );
      await loadItemsOfCategory(selectedCatForItems);
    } catch (err) {
      console.error("toggleItemHidden error:", err);
      alert("حصل خطأ أثناء التحديث، تأكد من اتصالك.");
    }
  }

  // ---------------------------
  // صور المنتج (مصفوفة) — الآن ترفع للـ ImgBB
  // ---------------------------

  async function addItemFiles(filesList) {
    if (!filesList || !filesList.length) return;

    const current = itemImages || [];
    const remaining = 4 - current.length;

    if (remaining <= 0) {
      alert("يمكنك رفع حتى 4 صور فقط لكل منتج.");
      return;
    }

    const files = Array.from(filesList).slice(0, remaining);

    try {
      setUploadingItemImages(true);

      const urls = await Promise.all(
        files.map((file) => uploadImageToImgBB(file))
      );

      setItemImages([...current, ...urls]);
    } catch (err) {
      console.error("addItemFiles (ImgBB) error:", err);
      alert("حصل خطأ أثناء رفع صور المنتج إلى ImgBB، تأكد من اتصالك.");
    } finally {
      setUploadingItemImages(false);
    }
  }

  async function handleItemImageFile(e) {
    const files = e.target.files;
    await addItemFiles(files);
    e.target.value = "";
  }

  async function handleItemImageDrop(e) {
    e.preventDefault();
    const files = e.dataTransfer.files;
    await addItemFiles(files);
  }

  function handleItemImageDragOver(e) {
    e.preventDefault();
  }

  function removeItemImage(index) {
    setItemImages((prev) => prev.filter((_, i) => i !== index));
  }

  // إضافة صورة من رابط (ما يحتاج ImgBB)
  function addItemImageFromUrl() {
    const url = itemImgUrl.trim();
    if (!url) return;
    if (itemImages.length >= 4) {
      alert("يمكنك إضافة حتى 4 صور فقط لكل منتج.");
      return;
    }
    setItemImages((prev) => [...prev, url]);
    setItemImgUrl("");
  }

  // حفظ / تعديل منتج
  async function saveItem() {
  if (!selectedCatForItems) {
    alert("اختر قسم أولاً.");
    return;
  }
  if (!itemName.trim()) {
    alert("اسم المنتج مطلوب.");
    return;
  }

  const newId = itemId ? itemId : Date.now().toString();

  const payload = {
    name: itemName || "",
    price: Number(itemPrice) || 0,
    calories: itemCalories ? Number(itemCalories) : undefined,
    desc: itemDesc || "",

    // ⭐ صور المنتج
    itemImages: itemImages || [],
    img: itemImages[0] || "",
    order: Number(itemPrice) || 0,

    // ⭐ الحقول الجديدة (مهم جداً)
    flourTypes: flourTypes,        // ← مصفوفة ["بر", "أبيض"]
    extras: extras,                // ← [{ name, price }]
  };

  await setDoc(
    doc(db, "menuCategories", selectedCatForItems, "items", newId),
    payload,
    { merge: true }
  );

  alert("تم حفظ المنتج بنجاح ✅");

  await loadItemsOfCategory(selectedCatForItems);

  // إعادة تعيين الحقول
  setItemId("");
  setItemName("");
  setItemPrice("");
  setItemCalories("");
  setItemDesc("");
  setItemImages([]);
  setExtras([]);
  setFlourTypes([]);
}


  // دالة مساعدة صغيرة لعرض صورة مصغرة في القوائم
  function SmallImg({ src }) {
    if (!src)
      return <div className="mini-banner placeholder">بدون صورة</div>;
    return (
      <img
        src={src}
        alt="item"
        className="mini-banner"
        style={{ objectFit: "contain", backgroundColor: "#fff" }}
      />
    );
  }

  // ---------------------------
  // واجهة المستخدم (لوحة تحكم حديثة)
  // ---------------------------

  return (
    <div className="admin-shell">
      {/* الشريط الجانبي للوحة التحكم */}
      <aside className="admin-sidebar">
        <div className="admin-sidebar-logo">
          <span className="admin-app-name">لوحة تحكم الفطيرة الدمشقية</span>
        </div>

        <nav className="admin-sidebar-nav">
          <button
            type="button"
            className={
              activeTab === "categories"
                ? "admin-nav-btn admin-nav-btn--active"
                : "admin-nav-btn"
            }
            onClick={() => setActiveTab("categories")}
          >
            الأقسام
          </button>

          <button
            type="button"
            className={
              activeTab === "items"
                ? "admin-nav-btn admin-nav-btn--active"
                : "admin-nav-btn"
            }
            onClick={() => setActiveTab("items")}
          >
            المنتجات
          </button>
        </nav>

        <div className="admin-sidebar-footer">
          <div className="admin-user-email">{user?.email}</div>
          <button
            className="admin-logout-btn"
            onClick={() => {
              if (window.confirm("تأكيد تسجيل الخروج؟")) signOut();
            }}
          >
            تسجيل الخروج
          </button>
        </div>
      </aside>

      {/* منطقة المحتوى الرئيسي */}
      <div className="admin-main-area">
        <header className="admin-header-bar">
          <div>
            <h1 className="admin-header-title">
              {activeTab === "categories" ? "إدارة الأقسام" : "إدارة المنتجات"}
            </h1>
            <p className="admin-header-subtitle">
              تحكم كامل في منيو الفطيرة الدمشقية من مكان واحد.
            </p>
          </div>
        </header>

        <main className="admin-content">
          {/* تبويب الأقسام */}
          {activeTab === "categories" && (
            <>
              {/* إضافة / تعديل قسم */}
              <section className="admin-card">
                <div className="admin-card-header">
                  <h2>إضافة / تعديل قسم</h2>
                  <button
                    type="button"
                    className="admin-mini-btn"
                    onClick={resetCategoryForm}
                  >
                    قسم جديد
                  </button>
                </div>

                <p className="hint">
                  اكتب الـ ID، عنوان القسم، الترتيب، وارفع حتى ٤ بانرات أعلى و٤
                  بانرات بعد القسم.
                </p>

                <div className="admin-grid-2">
                  <div className="admin-field">
                    <label>معرّف القسم (ID)</label>
                    <input
                      className="admin-input"
                      placeholder='مثال: "fatayer", "pizza"'
                      value={catId}
                      onChange={(e) => setCatId(e.target.value)}
                    />
                  </div>

                  <div className="admin-field">
                    <label>عنوان القسم</label>
                    <input
                      className="admin-input"
                      placeholder="مثلاً: الفطائر"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>

                  <div className="admin-field">
                    <label>ترتيب الظهور</label>
                    <input
                      className="admin-input"
                      type="number"
                      placeholder="مثال: 1"
                      value={orderNum}
                      onChange={(e) => setOrderNum(e.target.value)}
                    />
                  </div>
                </div>

                {/* ====== bannerTop (حتى ٤ صور) ====== */}
                <div className="admin-divider" />
                <h3 className="admin-subtitle">
                  بانرات أعلى القسم (حتى ٤ صور)
                </h3>

                <div className="banner-block">
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "0.5rem",
                      marginBottom: "0.5rem",
                    }}
                  >
                    {bannerTopList.length === 0 && (
                      <div className="drop-zone-hint">لا يوجد بانرات حالياً</div>
                    )}

                    {bannerTopList.map((src, idx) => (
                      <div key={idx} style={{ position: "relative" }}>
                        <img
                          src={src}
                          alt={`bannerTop ${idx}`}
                          className="banner-preview"
                          style={{ maxHeight: 80 }}
                        />
                        <button
                          type="button"
                          onClick={() => removeBannerImage("top", idx)}
                          className="badge-delete"
                        >
                          حذف
                        </button>
                      </div>
                    ))}
                  </div>

                  <div
                    className="drop-zone"
                    onDrop={(e) => handleDrop(e, "top")}
                    onDragOver={handleDragOver}
                  >
                    <div className="drop-zone-hint">
                      {uploadingTopBanners
                        ? "جاري رفع الصور..."
                        : "اسحب وأفلت حتى ٤ صور هنا أو اضغط لاختيار ملفات من جهازك"}
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      className="file-input"
                      onChange={(e) => handleBannerSelect(e, "top")}
                      disabled={uploadingTopBanners}
                    />
                  </div>
                </div>

                {/* ====== bannerAfter (حتى ٤ صور) ====== */}
                <div className="admin-divider" />
                <h3 className="admin-subtitle">
                  بانرات بعد القسم (حتى ٤ صور)
                </h3>

                <div className="banner-block">
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "0.5rem",
                      marginBottom: "0.5rem",
                    }}
                  >
                    {bannerAfterList.length === 0 && (
                      <div className="drop-zone-hint">لا يوجد بانرات حالياً</div>
                    )}

                    {bannerAfterList.map((src, idx) => (
                      <div key={idx} style={{ position: "relative" }}>
                        <img
                          src={src}
                          alt={`bannerAfter ${idx}`}
                          className="banner-preview"
                          style={{ maxHeight: 80 }}
                        />
                        <button
                          type="button"
                          onClick={() => removeBannerImage("after", idx)}
                          className="badge-delete"
                        >
                          حذف
                        </button>
                      </div>
                    ))}
                  </div>

                  <div
                    className="drop-zone"
                    onDrop={(e) => handleDrop(e, "after")}
                    onDragOver={handleDragOver}
                  >
                    <div className="drop-zone-hint">
                      {uploadingAfterBanners
                        ? "جاري رفع الصور..."
                        : "اسحب وأفلت حتى ٤ صور هنا أو اضغط لاختيار ملفات من جهازك"}
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      className="file-input"
                      onChange={(e) => handleBannerSelect(e, "after")}
                      disabled={uploadingAfterBanners}
                    />
                  </div>
                </div>

                <div style={{ marginTop: "1rem", textAlign: "left" }}>
                  <button className="save-btn" onClick={saveCategory}>
                    حفظ القسم
                  </button>
                </div>
              </section>

              {/* ---------- الأقسام الحالية ---------- */}
              <section className="admin-card">
                <div className="admin-card-header">
                  <h2>الأقسام الحالية</h2>
                  <span className="muted">
                    عدد الأقسام: {cats.length || 0}
                  </span>
                </div>

                {loadingCats && <div className="muted">...جارِ التحميل</div>}
                {!loadingCats && cats.length === 0 && (
                  <div className="muted">مافي أقسام لسه.</div>
                )}

                <div className="cats-list">
                  {cats.map((c) => {
                    const topThumb = Array.isArray(c.bannerTopImages)
                      ? c.bannerTopImages[0]
                      : c.bannerTop;
                    const afterThumb = Array.isArray(c.bannerAfterImages)
                      ? c.bannerAfterImages[0]
                      : c.bannerAfter;

                    return (
                      <div key={c.id} className="cat-row">
                        <div className="cat-main">
                          <strong>
                            {c.title || "(بدون عنوان)"}{" "}
                            {c.hidden && (
                              <span className="status-badge status-badge--hidden">
                                مخفي
                              </span>
                            )}
                          </strong>{" "}
                          <span className="muted">({c.id})</span>
                          <div className="muted">
                            الترتيب: {c.order ?? 0}
                          </div>
                        </div>

                        <div className="cat-banners">
                          {topThumb ? (
                            <img
                              src={topThumb}
                              alt="top"
                              className="mini-banner"
                            />
                          ) : (
                            <div className="mini-banner placeholder">
                              بدون bannerTop
                            </div>
                          )}

                          {afterThumb ? (
                            <img
                              src={afterThumb}
                              alt="after"
                              className="mini-banner"
                            />
                          ) : (
                            <div className="mini-banner placeholder">
                              بدون bannerAfter
                            </div>
                          )}
                        </div>

                        <div className="cat-actions">
                          <button
                            className="edit-btn"
                            onClick={() => startEditCategory(c)}
                          >
                            تعديل
                          </button>

                          <button
                            className="edit-btn"
                            onClick={() => toggleCategoryHidden(c)}
                          >
                            {c.hidden ? "إظهار القسم" : "إخفاء القسم"}
                          </button>

                          <button
                            className="delete-btn"
                            onClick={() => deleteCategory(c.id)}
                          >
                            حذف
                          </button>
                          <button
                            className="edit-btn"
                            onClick={() => {
                              setSelectedCatForItems(c.id);
                              loadItemsOfCategory(c.id);
                              setActiveTab("items");
                            }}
                          >
                            منتجات هذا القسم ⬇
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </section>
            </>
          )}

          {/* تبويب المنتجات */}
          {activeTab === "items" && (
            <>
              {/* إضافة / تعديل منتج */}
              <section className="admin-card">
                <div className="admin-card-header">
                  <h2>إضافة / تعديل منتج</h2>
                  <button
                    type="button"
                    className="admin-mini-btn"
                    onClick={resetItemForm}
                  >
                    منتج جديد
                  </button>
                </div>

                <p className="hint">
                  1) اختر القسم. 2) عبّي بيانات المنتج. 3) ارفع حتى ٤ صور (ملف أو
                  رابط).
                </p>

                <div className="admin-grid-2">
                  <div className="admin-field">
                    <label>القسم</label>
                    <select
                      className="admin-input"
                      value={selectedCatForItems}
                      onChange={(e) => {
                        setSelectedCatForItems(e.target.value);
                        loadItemsOfCategory(e.target.value);
                        resetItemForm();
                      }}
                    >
                      {cats.length === 0 && (
                        <option value="">(لا يوجد أقسام)</option>
                      )}
                      {cats.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.title || c.id}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="admin-field">
                    <label>اسم المنتج</label>
                    <input
                      className="admin-input"
                      placeholder="مثال: فطيرة جبن"
                      value={itemName}
                      onChange={(e) => setItemName(e.target.value)}
                    />
                  </div>

                  <div className="admin-field">
                    <label>السعر (ر.س)</label>
                    <input
                      className="admin-input"
                      type="number"
                      placeholder="مثال: 12"
                      value={itemPrice}
                      onChange={(e) => setItemPrice(e.target.value)}
                    />
                  </div>

                  <div className="admin-field">
                    <label>السعرات الحرارية (اختياري)</label>
                    <input
                      className="admin-input"
                      type="number"
                      placeholder="مثال: 350"
                      value={itemCalories}
                      onChange={(e) => setItemCalories(e.target.value)}
                    />
                  </div>
                </div>

                <div className="admin-field" style={{ marginTop: 12 }}>
                  <label>وصف قصير (اختياري)</label>
                  <input
                    className="admin-input"
                    placeholder="مثال: فطيرة جبن مشكلة بأكثر من نوع..."
                    value={itemDesc}
                    onChange={(e) => setItemDesc(e.target.value)}
                  />
                </div>

                <div className="admin-divider" />
                <h3 className="admin-subtitle">الإضافات (Options)</h3>

                <div className="admin-grid-2">
                  <div className="admin-field">
                    <label>اسم الإضافة</label>
                    <input
                      className="admin-input"
                      placeholder="مثال: جبنة زيادة"
                      value={extraName}
                      onChange={(e) => setExtraName(e.target.value)}
                    />
                  </div>

                  <div className="admin-field">
                    <label>سعر الإضافة</label>
                    <input
                      type="number"
                      className="admin-input"
                      placeholder="مثال: 2"
                      value={extraPrice}
                      onChange={(e) => setExtraPrice(e.target.value)}
                    />
                  </div>
                </div>

                <button
                  type="button"
                  className="edit-btn"
                  onClick={() => {
                    if (!extraName.trim() || !extraPrice) return alert("أدخل اسم + سعر");
                    setExtras([...extras, { name: extraName, price: Number(extraPrice) }]);
                    setExtraName("");
                    setExtraPrice("");
                  }}
                >
                  + إضافة
                </button>

                {/* عرض الإضافات */}
<div style={{ marginTop: "10px" }}>
  {extras.length === 0 && <div className="muted">لا توجد إضافات</div>}

  {extras.map((ex, i) => (
    <div key={i} className="option-row">
      {ex.name} — {ex.price} ر.س

      <button
        className="badge-delete"
        onClick={() =>
          setExtras(extras.filter((_, idx) => idx !== i))
        }
      >
        حذف
      </button>
    </div>
  ))}
</div>

                <div className="admin-divider" />
                <h3 className="admin-subtitle">أنواع العجينة</h3>

                <div className="admin-grid-2">
                  <div className="admin-field">
                    <label>أضف نوع عجينة</label>
                    <input
                      className="admin-input"
                      placeholder="مثال: عجينة بر"
                      value={flourInput}
                      onChange={(e) => setFlourInput(e.target.value)}
                    />
                  </div>
                </div>

                <button
                  type="button"
                  className="edit-btn"
                  onClick={() => {
                    if (!flourInput.trim()) return;
                    setFlourTypes([...flourTypes, flourInput.trim()]);
                    setFlourInput("");
                  }}
                >
                  + إضافة
                </button>

                {/* عرض أنواع العجينة */}
<div style={{ marginTop: "10px" }}>
  {flourTypes.length === 0 && <div className="muted">لا توجد خيارات عجينة</div>}

  {flourTypes.map((fl, i) => (
    <div key={i} className="option-row">
      {fl}

      <button
        className="badge-delete"
        onClick={() =>
          setFlourTypes(flourTypes.filter((_, idx) => idx !== i))
        }
      >
        حذف
      </button>
    </div>
  ))}
</div>



                {/* صور المنتج المتعددة */}
                <div className="admin-divider" />
                <h3 className="admin-subtitle">صور المنتج (حتى ٤ صور)</h3>

                {/* إدخال رابط صورة */}
                <div
                  style={{
                    display: "flex",
                    gap: "0.5rem",
                    marginBottom: "0.5rem",
                  }}
                >
                  <input
                    className="admin-input"
                    style={{ flex: 1 }}
                    placeholder="أو الصق رابط صورة مباشر https://...."
                    value={itemImgUrl}
                    onChange={(e) => setItemImgUrl(e.target.value)}
                  />
                  <button
                    type="button"
                    className="edit-btn"
                    onClick={addItemImageFromUrl}
                  >
                    + إضافة رابط
                  </button>
                </div>

                {/* ثَمب نيل للصور */}
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.5rem",
                    marginBottom: "0.5rem",
                  }}
                >
                  {itemImages.length === 0 && (
                    <div className="drop-zone-hint">لا يوجد صور حالياً</div>
                  )}

                  {itemImages.map((src, idx) => (
                    <div key={idx} style={{ position: "relative" }}>
                      <img
                        src={src}
                        alt={`item ${idx}`}
                        className="banner-preview"
                        style={{ maxHeight: 140 }}
                      />
                      <button
                        type="button"
                        onClick={() => removeItemImage(idx)}
                        className="badge-delete"
                      >
                        حذف
                      </button>
                    </div>
                  ))}
                </div>

                {/* رفع ملفات */}
                <div
                  className="drop-zone"
                  onDrop={handleItemImageDrop}
                  onDragOver={handleItemImageDragOver}
                >
                  <div className="drop-zone-hint">
                    {uploadingItemImages
                      ? "جاري رفع صور المنتج..."
                      : "اسحب وأفلت حتى ٤ صور المنتج هنا أو اضغط لاختيار ملفات من جهازك"}
                  </div>

                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    className="file-input"
                    onChange={handleItemImageFile}
                    disabled={uploadingItemImages}
                  />
                </div>

                <div style={{ marginTop: "1rem", textAlign: "left" }}>
                  <button className="save-btn" onClick={saveItem}>
                    حفظ المنتج
                  </button>
                </div>

                {itemId && (
                  <button
                    className="delete-btn"
                    style={{ marginTop: "0.5rem", width: "100%" }}
                    onClick={resetItemForm}
                  >
                    إلغاء التعديل / منتج جديد
                  </button>
                )}
              </section>

              {/* ---------- المنتجات الحالية للقسم المختار ---------- */}
              <section className="admin-card">
                <div className="admin-card-header">
                  <h2>المنتجات الحالية</h2>
                  <span className="muted">
                    {selectedCatForItems
                      ? `القسم: ${
                          cats.find((c) => c.id === selectedCatForItems)?.title ||
                          selectedCatForItems
                        }`
                      : "اختر قسم بالأعلى"}
                  </span>
                </div>

                {!selectedCatForItems && (
                  <div className="muted">اختر قسم بالأعلى لعرض منتجاته.</div>
                )}

                {selectedCatForItems && loadingItems && (
                  <div className="muted">...جارِ التحميل</div>
                )}

                {selectedCatForItems &&
                  !loadingItems &&
                  itemsList.length === 0 && (
                    <div className="muted">مافي منتجات لسه في هذا القسم.</div>
                  )}

                {selectedCatForItems && itemsList.length > 0 && (
                  <div className="cats-list">
                    {itemsList.map((it) => {
                      const thumbSrc =
                        (Array.isArray(it.itemImages) && it.itemImages[0]) ||
                        it.img;

                      return (
                        <div key={it.id} className="cat-row">
                          <div className="cat-main">
                            <strong>
                              {it.name || "(بدون اسم)"}{" "}
                              {it.hidden && (
                                <span className="status-badge status-badge--hidden">
                                  مخفي
                                </span>
                              )}
                            </strong>
                            <div className="muted">
                              سعر:{" "}
                              {typeof it.price !== "undefined"
                                ? it.price
                                : "؟"}{" "}
                              ر.س
                            </div>
                            {typeof it.calories !== "undefined" && (
                              <div className="muted">
                                سعرات: {it.calories} حرارية
                              </div>
                            )}
                            {it.desc && (
                              <div className="muted">وصف: {it.desc}</div>
                            )}
                          </div>

                          <div className="cat-banners">
                            <SmallImg src={thumbSrc} />
                          </div>

                          <div className="cat-actions">
                            <button
                              className="edit-btn"
                              onClick={() => startEditItem(it)}
                            >
                              تعديل المنتج
                            </button>

                            <button
                              className="edit-btn"
                              onClick={() => toggleItemHidden(it)}
                            >
                              {it.hidden ? "إظهار المنتج" : "إخفاء المنتج"}
                            </button>

                            <button
                              className="delete-btn"
                              onClick={() => deleteItem(it.id)}
                            >
                              حذف المنتج
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </section>
            </>
          )}

          <footer
            style={{
              textAlign: "center",
              color: "#9ad9c8",
              fontSize: ".8rem",
              padding: "2rem 0",
            }}
          >
            لوحة التحكم - الفطيرة الدمشقية
          </footer>
        </main>
      </div>
    </div>
  );
}
